import { styled, Box } from '@mui/material';

export const TreeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
}));

export const SearchContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  flexShrink: 0,
}));

export const TreeListContainer = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
});

interface TreeItemRowStyledProps {
  depth: number;
  focused?: boolean;
  selected?: boolean;
}

export const TreeItemRowStyled = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'depth' && prop !== 'focused' && prop !== 'selected',
})<TreeItemRowStyledProps>(({ theme, depth, focused, selected }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: 4,
  paddingBottom: 4,
  paddingRight: theme.spacing(1),
  paddingLeft: theme.spacing(1.5 + depth * 2),
  cursor: 'pointer',
  userSelect: 'none',
  transition: 'background-color 0.15s ease, border-left 0.15s ease',
  borderLeft: focused
    ? `3px solid ${theme.palette.warning.main}`
    : '3px solid transparent',
  backgroundColor: selected
    ? theme.palette.action.selected
    : focused
      ? theme.palette.warning.light + '22'
      : 'transparent',
  '&:hover': {
    backgroundColor: selected
      ? theme.palette.action.selected
      : theme.palette.action.hover,
  },
}));

export const ExpandIconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<{ expanded?: boolean }>(({ expanded }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  marginRight: 4,
  transition: 'transform 0.2s ease',
  transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
  flexShrink: 0,
}));

export const NodeIconWrapper = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(0.75),
  flexShrink: 0,
}));

export const NodeLabel = styled(Box)({
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '0.875rem',
  lineHeight: 1.5,
});

export const EmptyTreeMessage = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  color: theme.palette.text.secondary,
  textAlign: 'center',
}));
